import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-lake',
  templateUrl: './data-lake.component.html',
  styleUrls: ['./data-lake.component.sass']
})
export class DataLakeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
